/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';

import { TransferPricingAudience } from 'landing-pages/transfer-pricing/sections/TransferPricingAudience/TransferPricingAudience';
import { TransferPricingClassification } from 'landing-pages/transfer-pricing/sections/TransferPricingClassification/TransferPricingClassification';
import { TransferPricingComparison } from 'landing-pages/transfer-pricing/sections/TransferPricingComparison/TransferPricingComparison';
import { TransferPricingExposure } from 'landing-pages/transfer-pricing/sections/TransferPricingExposure/TransferPricingExposure';
import { TransferPricingFinalCta } from 'landing-pages/transfer-pricing/sections/TransferPricingFinalCta/TransferPricingFinalCta';
import { TransferPricingGroupLinkage } from 'landing-pages/transfer-pricing/sections/TransferPricingGroupLinkage/TransferPricingGroupLinkage';
import { TransferPricingGroupScreening } from 'landing-pages/transfer-pricing/sections/TransferPricingGroupScreening/TransferPricingGroupScreening';
import { TransferPricingHero } from 'landing-pages/transfer-pricing/sections/TransferPricingHero/TransferPricingHero';
import { TransferPricingRegis } from 'landing-pages/transfer-pricing/sections/TransferPricingRegis/TransferPricingRegis';
import { TransferPricingScreening } from 'landing-pages/transfer-pricing/sections/TransferPricingScreening/TransferPricingScreening';
import { TransferPricingSourcing } from 'landing-pages/transfer-pricing/sections/TransferPricingSourcing/TransferPricingSourcing';
import { TransferPricingTieOut } from 'landing-pages/transfer-pricing/sections/TransferPricingTieOut/TransferPricingTieOut';

import styles from './TransferPricingPage.module.scss';

import { getAccessRoutes } from './TransferPricingPage.data';

export const TransferPricingPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <TransferPricingHero />
      <TransferPricingExposure />
      <TransferPricingAudience />
      <TransferPricingSourcing />
      <TransferPricingScreening />
      <TransferPricingClassification />
      <TransferPricingGroupLinkage />
      <TransferPricingRegis />
      <TransferPricingTieOut />
      <TransferPricingGroupScreening />
      <TransferPricingComparison />
      <AccessRoutes
        background="navy"
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset. Pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <TransferPricingFinalCta />
    </div>
  );
};
